<template>
    <div class="text-error mt-2" aria-live="assertive">
        <slot />
    </div>
</template>
